export function getLocalStorageItem(key: string, defaultValue?: unknown) {
  const item = localStorage.getItem(key)

  if (item != null) {
    try {
      return JSON.parse(item)
    } catch {
      return item || null
    }
  }

  if (defaultValue instanceof Function) {
    return defaultValue()
  }

  return defaultValue
}

export function setLocalStorageItem(key: string, value: unknown) {
  if (typeof value === 'string') {
    localStorage.setItem(key, value)
    return
  }
  localStorage.setItem(key, JSON.stringify(value))
}

export function removeLocalStorageItem(key: string) {
  localStorage.removeItem(key)
}
